export const whatsappNumber = '16892995809'
export const whatsappUrl = `https://wa.me/${whatsappNumber}`
export const applicationFormUrl = 'https://tally.so/r/xVrMMd'
